export const CREATE_MULTIPART_UPLOAD = 'create-multipart-upload';

export const PREPARE_UPLOAD_PARTS = 'prepare-upload-parts';

export const COMPLETE_MULTIPART_UPLOAD = 'complete-multipart-upload';

export const ABORT_MULTIPART_UPLOAD = 'abort-multipart-upload';

export const LIST_PARTS = 'list-parts';
